// extracted by mini-css-extract-plugin
module.exports = {"root":"layout_root__42iGe","childContainer":"layout_childContainer__319xx","content":"layout_content__1PoEv"};